import { useSelector } from 'react-redux';
import { evaluatedPolicySelectors } from '../redux/modules/evaluatedPolicy';
import { enforce, permissions } from '../util/abac';
import { projectPickerSelectors } from '../redux/modules/projectPicker';

type CanPerformFunc = (...perms: any[]) => boolean;

export const useABAC = (): [CanPerformFunc, typeof permissions] => {
  const policy = useSelector(evaluatedPolicySelectors.selectPolicyForUser);
  const activeProjectId = useSelector(
    projectPickerSelectors.selectActiveProjectId,
  );

  const canPerform: CanPerformFunc = (...perms) => {
    return perms.every(
      key =>
        enforce(key, policy, { resource: { dataset: activeProjectId } }) ===
        true,
    );
  };

  return [canPerform, permissions];
};

export default useABAC;
